module.exports = __webpack_public_path__ + "static/media/top-venue-icon.8c149489.svg";